module.exports = __webpack_public_path__ + "static/img/Scenes08.ba40341.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Scenes08.svg
// module id = fXW7
// module chunks = 1